import React from 'react';
import { MetricUId } from '../../Metrics/constants';
import { getMetricDataFromArray } from '../../Metrics/utils';
import i18n from '../../../../utils/ChrI18n';
import LikertScaleChart from '../../Reports/templates/LikertScaleChart';
import ChrMeetingRatingReasons from '../../Reports/templates/ChrMeetingRatingReasons';
import { getMeetingRatingReasonsChartConfig, metricColorMap } from '../chartConfigUtils';

const Body = (props) => {
  const { metrics } = props;
  const { ratings, headers, last7DaysResponses = null } = getMetricDataFromArray(metrics, MetricUId.MEETING_RATING_RESPONSES).data;

  const numberOfReasonsToDisplay = 3;
  const goodReasonsMetric = getMetricDataFromArray(metrics, MetricUId.GOOD_MEETING_RATING_REASONS);
  const badReasonsMetric = getMetricDataFromArray(metrics, MetricUId.BAD_MEETING_RATING_REASONS);
  const chartClasses = 'col-12 col-xs-6 d-flex flex-column cui-flex-gap-20 p-20'

  return (
    <div className="d-flex flex-column flex-md-row">
      {/* Likert Scale Chart */}
      <div className="cui-flex-3 cui-meeting-feedback-widget-border">
        <LikertScaleChart
          ratings={ratings}
          headers={headers}
          headerSubtext={last7DaysResponses}
        />
      </div>

      {/* Bar Charts */}
      <div className="cui-flex-7 p-t-20 p-l-12">
        <div className="font-13 font-500 p-x-12">
          {i18n.t("widgets.meeting_feedbacks.reason_title", jsConstants.customTerms)}
        </div>
        <div className="container">
          <div className="row">
            <ChrMeetingRatingReasons
              title={goodReasonsMetric.name}
              chartOptions={
                getMeetingRatingReasonsChartConfig(
                  goodReasonsMetric.data.reasons.slice(0, numberOfReasonsToDisplay), {
                    color: metricColorMap[MetricUId.GOOD_MEETING_RATING_REASONS],
                    height: 200
                  }
                )
              }
              chartClasses={chartClasses}
            />
            <ChrMeetingRatingReasons
              title={badReasonsMetric.name}
              chartOptions={
                getMeetingRatingReasonsChartConfig(
                  badReasonsMetric.data.reasons.slice(0, numberOfReasonsToDisplay), {
                    color: metricColorMap[MetricUId.BAD_MEETING_RATING_REASONS],
                    height: 200
                  }
                )
              }
              chartClasses={chartClasses}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Body;
